import type { HttpMock } from '#e2e-utils/mockScenarios';
import { ControllerStatus } from '#models/ControllerStatus.enum';
import { ControllerCode } from '#models/MicroController.model';
import { ControllerDetails } from '#services/cve/ControllerDetails';

export const validateKycMocks: HttpMock[] = (
  [
    'AccountDetails',
    'AccountOwner',
    'CompanyGrade',
    'PreviousNegociation',
    'TradeSector',
    'PreviousContract',
    'SensitiveBusiness',
    'SensitiveCountry',
    'EnergyPolicy',
    'EconomicSanctions',
    'PoliticalExposedPerson',
    'ProspectLocation',
    'BuExchangeGroup',
    'MncList',
    'ReputationalRisk',
    'UnpaidPremiumAndFees',
    'CompanyConsortOrCoop',
    'Gerl',
  ] as ControllerCode[]
).map((controlCode) => ({
  request: {
    method: 'GET',
    urlPathPattern: `^/iterations/iterationId/controls/${controlCode}$`,
  },
  response: {
    status: 200,
    body: {
      controlCode,
      statusCode: ControllerStatus.ACKNOWLEDGED_WITH_CHECK_SUCCESS,
      check: {
        requestorId: 'CVE',
        requestDateTime: '2024-05-21T13:29:56.409Z',
        responseDateTime: '2024-05-21T13:29:56.409Z',
        expirationDateTime: '2025-05-21T13:29:56.409Z',
        controlData: {},
      },
      validation: {
        requestorId: 'CVE',
        validationDateTime: '2024-05-21T13:29:56.409Z',
      },
    } satisfies ControllerDetails,
  },
}));
